import { assign, cloneDeep, sortBy } from 'lodash'

export default {
  INITIALISE_STORE(state) {
    if (localStorage.getItem('truckme-vuex')) {
      this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem('truckme-vuex')))
      )
    }
  },
  SET_USUARIO(state, data) {
    state.Usuario = data
  },
  SET_EMBARCADOR(state, data) {
    let cnaes = []
    let clone = cloneDeep(data)

    try {
      clone.cnaes.forEach((cnaeId) => {
        cnaes.push({ id: cnaeId })
      })
      clone.cnaes = cnaes
    } catch (e) {}

    state.Embarcador = clone
  },
  ADD_COLABORADOR(state, colaborador) {
    let houveAlteracao = false

    state.Embarcador.colaboradores.map((c) => {
      if (c.id === colaborador.id) {
        houveAlteracao = true
        return assign(c, colaborador)
      }
    })

    if (!houveAlteracao) {
      state.Embarcador.colaboradores.push(cloneDeep(colaborador))
    }
  },
  DEL_COLABORADOR(state, id) {
    state.Embarcador.colaboradores = state.Embarcador.colaboradores.filter(
      (c) => c.id !== id
    )
  },
  DEL_TRANSPORTADOR(state, id) {
    state.Embarcador.transportadores = state.Embarcador.transportadores.filter(
      (c) => c.id !== id
    )
  },
  SET_ESTADOS(state, response) {
    let estados = response.data

    // ordena os estados por nome
    estados = sortBy(estados, ['nome'])

    state.Estados = estados
  },
  SET_CIDADES(state, { estadoId, response }) {
    let cidades = response.data

    // ordena os cidades por nome
    cidades = sortBy(cidades, ['nome'])

    state.Cidades[estadoId] = cidades
  },
  SET_CNAES(state, { response }) {
    let cnaes = response.data

    // ordena os cnaes por nome
    cnaes = sortBy(cnaes, ['classe'])

    state.Cnaes = cnaes
  },
  SET_GERENCIADORAS_RISCO(state, { response }) {
    let cnaes = response.data

    // ordena as gerenciadoras por nome
    gerenciadoraRisco = sortBy(gerenciadoraRisco, ['nome'])

    state.GerenciadoraRisco = gerenciadoraRisco
  },
  SET_TOTAL_FRETES_RASCUNHO(state, total) {
    state.TotalFretesRascunho = total
  },
  SET_AUTH_LOGIN_EXPIRED(state, payload) {
    state.Auth.login.expired = payload
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js